import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons';
import styled from 'styled-components';

import { SocialUser } from '#src/components/user/SocialUser/index.tsx';

import type { TwitterUser_userProfile } from './__generated__/index.graphql.ts';

const Root = styled.a`
  color: inherit;
  &:hover {
    color: inherit;
    text-decoration: underline;
  }
`;
type Props = {
  userProfile: TwitterUser_userProfile;
  coloredIcon?: boolean;
};

export const TwitterUser = ({
  userProfile: { twitterUsername },
  coloredIcon,
}: Props) => {
  if (!twitterUsername) return null;

  return (
    <Root
      href={`https://x.com/${twitterUsername}`}
      target="_blank"
      rel="noreferrer noopener"
    >
      <SocialUser
        nickname={twitterUsername}
        icon={faXTwitter}
        prefix="@"
        color={coloredIcon ? 'var(--c-social-x-twitter)' : undefined}
      />
    </Root>
  );
};

TwitterUser.fragments = {
  userProfile: gql`
    fragment TwitterUser_userProfile on UserProfile {
      id
      twitterUsername
    }
  ` as TypedDocumentNode<TwitterUser_userProfile>,
};
